import { ConfigProvider, Segmented } from "antd";
import "./BrandSegmented.css";

const segmentedTheme = (overrides) => ({
  components: {
    Segmented: {
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      fontSize: 13,
      controlHeight: 32,
      controlPaddingHorizontal: 13,
      borderRadius: 8,
      borderRadiusSM: 6,
      trackPadding: 3,
      trackBg: "#f1f5f9",
      itemColor: "#475569",
      itemHoverColor: "#0f172a",
      itemHoverBg: "rgba(15, 23, 42, 0.06)",
      itemActiveBg: "rgba(15, 23, 42, 0.1)",
      itemSelectedBg: "#fb310d",
      itemSelectedColor: "#ffffff",
      ...overrides,
    },
  },
});

const THEME = segmentedTheme({});
const COMPACT_THEME = segmentedTheme({ fontSize: 12, controlHeight: 28, controlPaddingHorizontal: 9 });

const BrandSegmented = ({ compact = false, className, ...props }) => (
  <ConfigProvider theme={compact ? COMPACT_THEME : THEME}>
    <Segmented className={className ? `brand-segmented ${className}` : "brand-segmented"} {...props} />
  </ConfigProvider>
);

export default BrandSegmented;
